export type EventPayload = {
  id: string;
  payload: Record<string, unknown>;
  metadata?: Record<string, unknown>;
};

export enum AutomationEventTypes {
  Automation = 'automation',
  AutomationVersion = 'automation_version',
  Dataset = 'dataset',
  LinkedDataset = 'linked_dataset',
  StaticDataset = 'static_dataset',
  Run = 'run',
  Execution = 'execution',
  IntegrationActionSelectFieldOptions = 'integration_action_select_field_options',
}

export type AutomationEventType = (typeof AutomationEventTypes)[keyof typeof AutomationEventTypes];

export enum RunEventTypes {
  StepRun = 'step_run',
  StepExecution = 'step_execution',
  StepExecutionInputDataset = 'step_execution_input_dataset',
  StepExecutionOutputDataset = 'step_execution_output_dataset',
  StepExecutionLog = 'step_execution_log',
  ExtractErrorLog = 'extract_error_log',
  ChatMessage = 'chat_message',
  ExtractEntity = 'extract_entity',
  ExtractEntityField = 'extract_entity_field',
}

export type RunEventType = (typeof RunEventTypes)[keyof typeof RunEventTypes];

export type ServerSideEventType = AutomationEventType | RunEventType;
